import {useEffect, useState} from "react";
import {observer} from "mobx-react";

// Components
import MDButton from "components/MDButton";
import AdminLayout from "components/AdminLayout";

//Utils
import {truncate, useApi, useIsMobile} from "../../../services/helpers";
import {AddProductModal} from "./components/AddProductModal";
import ConfirmDialogModal from "../../../components/ConfirmDialogModal";
import pxToRem from "../../../assets/theme/functions/pxToRem";
import {popoverActionsIcon} from "../../../components/PopoverActionsIcon";
import DataTable from "components/DataTable";
import {FilterModalForm} from "./components/FilterModalForm";
import {PopoverDeleteText} from "../../../components/PopoverActions/PopoverEditDelete";
import {PopoverActions, PopoverItem} from "../../../components/PopoverActions";
import SearchBar from "../../../components/SearchBar";
import MDBox from "../../../components/MDBox";
import {useApiMessages} from "../../../services/api/api-messages";
import {AddOptionValueModal} from "./components/AddOptionValueModal";
import {AddPackageModal} from "./components/AddPackageModal";


const VIEW_OPTIONS = { GROUPS: 1, OPTIONS: 2 }
export const groupDataTableModel = {
  columns: [
    {Header: "Name", accessor: "name"},
    {Header: "Products", accessor: "products_names", disableOrdering: true},
    {Header: "Packages", accessor: "packages_names", disableOrdering: true},
    {Header: "", accessor: "actions", align: "left", disableOrdering: true, width: pxToRem(5)}
  ],
  rows: [],
};

export const optionDataTableModel = {
  columns: [
    {Header: "Name", accessor: "name"},
    {Header: "Options", accessor: "options_names", disableOrdering: true},
    {Header: "", accessor: "actions", align: "left", disableOrdering: true, width: pxToRem(5)}
  ],
  rows: [],
};


function ManageFiltersPage() {
  const api = useApi()
  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [viewOption, setViewOption] = useState(VIEW_OPTIONS.GROUPS);
  const [groupDatatable, setGroupDatatable] = useState({...groupDataTableModel});
  const [optionDatatable, setOptionDatatable] = useState({...optionDataTableModel});
  const [openPopover, setOpenPopover] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [paginationData, setPaginationData] = useState({
    counts: 0,
    itemsPerPage: 0,
    currentPage: 1,
    ordering: "",
  });
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [openAddProductModal, setOpenAddProductModal] = useState(false)
  const [openAddPackageModal, setOpenAddPackageModal] = useState(false)
  const [openAddOptionValueModal, setOpenAddOptionValueModal] = useState(false)
  const [openFilterModalForm, setOpenFilterModalForm] = useState(false)
  const [searchQuery, setSearchQuery] = useState('');
  const messages = useApiMessages('project', 'projects')
  const isMobile = useIsMobile()
  const renderGroupTableRow = (item, setAnchorEl, setOpenPopover, setSelectedItem) => {
    // item.name = item.name
    item.products_names = truncate(item.products_names, 30)
    item.packages_names = truncate(item.packages_names, 30)
    item.actions = (popoverActionsIcon(item, setAnchorEl, setOpenPopover, setSelectedItem))
    return item
  }

  const renderOptionTableRow = (item, setAnchorEl, setOpenPopover, setSelectedItem) => {
    // item.name = item.name
    item.options_names = truncate(item.options_names, 30)
    item.actions = (popoverActionsIcon(item, setAnchorEl, setOpenPopover, setSelectedItem))
    return item
  }

  const onGet = (searchData = '', page = 1, ordering = paginationData.ordering, page_size = 25) => {
    setLoading(true)
    if (viewOption === VIEW_OPTIONS.GROUPS) {
      api.getProductGroups({search: searchData, page, ordering}).handle({
          onSuccess: (result) => {
            const {count, results} = result.data
            const tmp = {...groupDataTableModel}
            tmp.rows = results.map(e => renderGroupTableRow(e, setAnchorEl, setOpenPopover, setSelectedItem))
            setGroupDatatable(tmp)
            setPaginationData(value => ({...value, counts: count, itemsPerPage: results.length, ordering}))
          },
          errorMessage: messages.list.error,
          onFinally: () => setLoading(false)
        }
      )
    } else {
      api.getFeatures({search: searchData, page, ordering}).handle( {
          onSuccess: (result) => {
            const {count, results} = result.data
            const tmp = {...optionDataTableModel}
            tmp.rows = results.map(e => renderOptionTableRow(e, setAnchorEl, setOpenPopover, setSelectedItem))
            setOptionDatatable(tmp)
            setPaginationData(value => ({...value, counts: count, itemsPerPage: results.length, ordering}))
          },
          errorMessage: messages.list.error,
          onFinally: () => setLoading(false)
        }
      )
    }
  }

  const onDelete = () => {
    setLoading(true)
    if (viewOption === VIEW_OPTIONS.GROUPS) {
      api.deleteProductGroup(selectedItem?.id).handle({
          successMessage: messages.delete.success,
          onSuccess: () => {
            onGet('');
            onClose()
          },
          errorMessage: messages.delete.error,
          onFinally: () => setLoading(false)
        }
      )
    }
    else {
      api.deleteFeature(selectedItem?.id).handle({
          successMessage: messages.delete.success,
          onSuccess: () => { onGet(''); onClose() },
          errorMessage: messages.delete.error,
          onFinally: () => setLoading(false)
        }
      )
    }
  }

  const onClose = () => {
    setOpenPopover(false)
    setSelectedItem(null)
    setOpenConfirmModal(false)
    setOpenFilterModalForm(false)
  }

  useEffect(() => {
    onGet()
  }, [viewOption])


  return (
    <AdminLayout
      title={ viewOption === VIEW_OPTIONS.GROUPS? 'Manage Groups': 'Manage Options' }
      header={
        <MDBox display={'flex'} flex={1} flexDirection={'row'} alignItems={'center'}>
          <MDButton variant={viewOption===VIEW_OPTIONS.GROUPS? "contained" : "outlined"} color="secondary" type='button'
                    onClick={() => {setViewOption(VIEW_OPTIONS.GROUPS)}}
                    sx={isMobile ? { fontSize:"14px", flexWrap:"nowrap", width:"178px", alignContent:"center", pb:"6px"}:{mr:"16px"}}>
            Group
          </MDButton>
          <MDButton variant={viewOption===VIEW_OPTIONS.OPTIONS? "contained" : "outlined"} color="secondary" type='button'
                    onClick={() => {setViewOption(VIEW_OPTIONS.OPTIONS)}}
                    sx={isMobile ? { fontSize:"14px", flexWrap:"nowrap", width:"178px", alignContent:"center", pb:"6px"}:{}}>
            Feature
          </MDButton>
          <SearchBar loading={loading} search={onGet} setSearchQuery={setSearchQuery}/>
          <MDButton variant="contained" color="secondary" type='button' onClick={() => setOpenFilterModalForm(true)}
                    sx={isMobile ? { fontSize:"14px", flexWrap:"nowrap", width:"178px", alignContent:"center", pb:"6px"}:{}}>
            {`Add New ${viewOption===VIEW_OPTIONS.GROUPS? 'Group': 'Option'}`}
          </MDButton>
        </MDBox>
      }
    >

      <DataTable
        loading={loading}
        loadingText={'Loading...'}
        table={viewOption === VIEW_OPTIONS.GROUPS? groupDatatable: optionDatatable}
        currentPage={paginationData.currentPage}
        numberOfItems={paginationData.counts}
        numberOfItemsPage={paginationData.itemsPerPage}
        searchFunc={onGet}
        searchQuery={searchQuery}
        onPageChange={page => {
          onGet(searchQuery, page)
          setPaginationData(value => ({...value, currentPage: page}))
        }}
      />

      {openFilterModalForm && (
        <FilterModalForm
          item={selectedItem}
          open={openFilterModalForm}
          onClose={() => setOpenFilterModalForm(false)}
          setLoading={setLoading}
          loading={loading}
          isGroup={viewOption === VIEW_OPTIONS.GROUPS}
          onSave={() => {
            onClose()
            onGet(searchQuery);
          }}/>
      )}

      {openAddProductModal && (
        <AddProductModal
          open={openAddProductModal}
          item={selectedItem}
          loading={loading}
          onUpdate={() => {
            onGet(searchQuery)
          }}
          onClose={() => {
            onClose()
            setOpenAddProductModal(false)
            setOpenPopover(false)
            onGet(searchQuery)
          }}/>
      )}

      {openAddPackageModal && (
        <AddPackageModal
          open={openAddPackageModal}
          item={selectedItem}
          loading={loading}
          onUpdate={() => {
            onGet(searchQuery)
          }}
          onClose={() => {
            onClose()
            setOpenAddPackageModal(false)
            setOpenPopover(false)
            onGet(searchQuery)
          }}/>
      )}

      {openAddOptionValueModal && (
        <AddOptionValueModal
          open={openAddOptionValueModal}
          item={selectedItem}
          loading={loading}
          onUpdate={() => {
            onGet(searchQuery)
          }}
          onClose={() => {
            onClose()
            setOpenAddOptionValueModal(false)
            setOpenPopover(false)
            onGet(searchQuery)
          }}/>
      )}

      <ConfirmDialogModal
        title={'Do you want to delete this item?'}
        description={`${selectedItem?.name}`}
        cancelText={'Cancel'}
        confirmText={'Confirm'}
        open={openConfirmModal}
        handleClose={() => onClose()}
        handleConfirm={() => onDelete()}
      />

      <PopoverActions open={openPopover} onClose={onClose} anchorEl={anchorEl}>
        <PopoverItem label={"Edit"} onClick={() => setOpenFilterModalForm(true)}/>
        {viewOption === VIEW_OPTIONS.GROUPS?
          (<>
            <PopoverItem label={"Manage Products"} onClick={() => setOpenAddProductModal(true)}/>
            <PopoverItem label={"Manage Packages"} onClick={() => setOpenAddPackageModal(true)}/>
          </>)
          :
          (<PopoverItem label={"Manage Options"} onClick={() => setOpenAddOptionValueModal(true)}/>)
        }
        <PopoverItem label={"Delete"} onClick={() => setOpenConfirmModal(true)} sx={PopoverDeleteText}/>
      </PopoverActions>
    </AdminLayout>
  );
}

export default observer(ManageFiltersPage);
